import React from 'react';
import { TrendingUp, Handshake, Search } from 'lucide-react';

export default function WhatWeDo() {
  const services = [
    {
      icon: TrendingUp,
      title: 'Capital Markets',
      description: 'Facilitating access to Indian capital markets as an Authorised Person of Marwadi Shares and Finance Limited.'
    },
    {
      icon: Handshake,
      title: 'Market Research & Insights',
      description: 'Research-driven analysis of market trends, businesses and macroeconomic developments to support informed decision-making.'
    },
    {
      icon: Search,
      title: 'Execution & Market Support',
      description: 'Focused on efficient trade execution, responsive support and a disciplined approach to market participation.'
    }
  ];

  return (
    <section id="what-we-do" className="py-12 sm:py-16 md:py-24 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center mb-10 sm:mb-12 md:mb-16">
          <h2 className="font-heading font-bold text-3xl sm:text-4xl md:text-5xl text-foreground mb-4 sm:mb-6">
            Our Expertise
          </h2>
          <p className="text-base sm:text-lg text-muted-foreground leading-relaxed px-2">
            Market access, execution and research across Indian financial markets.

          </p>
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-card border border-border rounded-lg p-8 hover:border-accent/50 hover:shadow-lg transition-all duration-300"
            >
              <div className="mb-6">
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-lg bg-accent/10 text-accent">
                  <service.icon className="h-8 w-8" />
                </div>
              </div>
              <h3 className="font-heading font-semibold text-xl text-foreground mb-4">
                {service.title}
              </h3>
              <p className="text-muted-foreground leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}